import {Component} from '@angular/core';
import {ViewController, NavParams} from 'ionic-angular';
import {InspectionType} from '../../../../../services/inspectiontype.service';

@Component({
    template: `
        <ion-list>
            <ion-list-header color="dark">Inspections</ion-list-header>
            <button ion-button full color="light" *ngFor="let x of inspectionList" (click)="selectItem(x)">{{x.name}}</button>
        </ion-list>
    `,
})
export class InspectionPopover {

    // Declare our preset title list
    private inspectionList : InspectionType[];

    constructor( 
        public viewCtrl : ViewController,
    ) {
        // Assign our title list to our preset list
        let navParams : NavParams = this.viewCtrl.getNavParams();
        this.inspectionList = navParams.get("inspectionTypes");
    }
    
    selectItem(item : InspectionType) {
        this.viewCtrl.dismiss({
            selected: item
        });
    }
}
    


// WEBPACK FOOTER //
// ./src/pages/report/tab-main/inspection/inspection-popover/inspection-popover.component.ts